export enum WesterosClientsModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
